import { render, staticRenderFns } from "./MenuModules.vue?vue&type=template&id=36a8e5d5&"
import script from "./MenuModules.vue?vue&type=script&lang=js&"
export * from "./MenuModules.vue?vue&type=script&lang=js&"
import style0 from "./MenuModules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports